import { createApp } from 'vue'
import * as Sentry from '@sentry/vue'
import './style.css'
import App from './App.vue'
import router from './router'
import { inject } from '@vercel/analytics'

// Initialize Vercel Analytics
inject()

const app = createApp(App)

// ── Sentry Error Monitoring ──────────────────────────────────
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN
if (SENTRY_DSN) {
  Sentry.init({
    app,
    dsn: SENTRY_DSN,
    environment: import.meta.env.MODE, // 'development' | 'production'
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],
    // Performance: capture 10% of transactions in production
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    // Session Replay: 10% baseline, 100% on errors
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    // Only send errors from our own domain (Prevents local dev quota burn)
    allowUrls: [/lewotobi\.com/],
  })
}

// Initialize Supabase Auth Listener (Wait for session restoration)
import { useAuth } from './stores/useAuth.js';
const auth = useAuth();
await auth.initAuth();

app.use(router)
app.mount('#app')
